import { render, staticRenderFns } from "./JoinJob.vue?vue&type=template&id=13a1c58a&"
import script from "./JoinJob.vue?vue&type=script&lang=js&"
export * from "./JoinJob.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports